export default __webpack_public_path__ + "static/media/yourturn-landing(desktop).09f3721c.png";